<template>
  <div class="border rounded-lg shadow-sm p-2">
    <div class="flex items-center">
      <div class="hover:cursor-pointer" @click="dialogManageLogos.start()">
        <img v-if="hasValue" :src="modelValue" alt="Logo" class="min-w-[4rem] w-[6rem] border rounded-lg p-2" />
        <Skeleton v-else animation="none" size="5rem" class=""></Skeleton>
      </div>
      <div class="ml-2 flex-grow">
        <div class="text-md font-semibold text-blue-500 hover:underline cursor-pointer" @click="dialogManageLogos.start()">Change Logo ...</div>
        <div class="text-xs text-gray-500">{{ modelValue }}</div>
      </div>
    </div>
    <DialogManageLogos ref="dialogManageLogos" @logoSelected="onLogoSelected"></DialogManageLogos>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import DialogManageLogos from '@/components/Selectors/DialogManageLogos.vue';
  import Skeleton from 'primevue/skeleton';

  // TODO Pass background as prop and use it
  const props = defineProps({
    modelValue: {
      type: String,
      default: null,
    },
  });
  const emit = defineEmits(['update:modelValue']);

  const dialogManageLogos = ref(null);
  const hasValue = computed(() => props.modelValue !== null && props.modelValue !== '');

  async function onOpen() {
    dialogManageLogos.value.start();
  }

  function onLogoSelected(url) {
    emit('update:modelValue', url);
  }
</script>
